export const CONTENT_VIEW_TYPES = {
  newsletter: 'newsletter',
  news: 'news',
  topic: 'topic',
  story: 'story',
  international: 'international',
  release: 'release',
  activity: 'activity',
  activity_news: 'activity_news',
  ad: 'ad',
  image: 'image',
};

/** 详情加载后调用一次；失败静默，成功返回最新 views */
export async function trackContentView(store, type, id, currentViews = 0) {
  try {
    const res = await store.dispatch('common/reportContentView', {
      type,
      id: Number(id),
    });
    return res?.views ?? currentViews;
  } catch (_) {
    return currentViews;
  }
}
